"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LazyOnScroll = void 0;
var _mui = require("@ori-ui/mui");
var _react = _interopRequireDefault(require("react"));
var _reactCoolInview = require("react-cool-inview");
var _jsxRuntime = require("react/jsx-runtime");
const Wrapper = (0, _mui.styled)('div')(({
  minHeight,
  isLoaded
}) => ({
  minHeight,
  // optimizes performance and prevents Margin Collapsing https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Box_Model/Mastering_margin_collapsing
  contain: 'layout',
  ...(isLoaded && {
    '&:empty': {
      display: 'none'
    }
  })
}));
/**
 * Wrapper which makes it's children component lazy-loaded if the user scrolls
 * near the component.
 *
 * **IMPORTANT** `children` has to be a lazyloaded component either via
 * _Next's_ `dynamic()` or `React.lazy()`.
 *
 * @returns `<div>` element wrapping the lazy loaded component.
 */
const LazyOnScroll = ({
  options,
  minHeight,
  testId,
  children,
  isLoaded
}) => {
  const {
    observe,
    inView
  } = (0, _reactCoolInview.useInView)({
    onEnter: ({
      unobserve
    }) => unobserve(),
    ...options
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Wrapper, {
    ref: observe,
    minHeight: minHeight,
    isLoaded: !!isLoaded,
    "data-testid": testId,
    children: !!inView && children
  });
};
exports.LazyOnScroll = LazyOnScroll;
